module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
	
	var	_;

	_ = {
		cleanUnusedData: function () {
			this.unusedDataLabelTimer = setTimeout(fox.bind(function () {
				this.resetCollection();
			}, this), this.getOption('cleanUnusedDataTime'));
		},

		initDatalayer: function () {
			var
				dl;

			this.embedWidgetsFromOptions();

			dl = this.wom1('.Datalayer');

			if (dl) {
				this.dl = dl;
			} else if (this.getParent().dl) {
				this.dl = this.getParent().dl;
			}

			if (!this.dl.isRun()) {
				this.dl.run();
			}

			if (!fox._isNewfe) {
				this.dl.addFields(fox.Zen(this.requireOption('tpl.row'), 'prepare').plainVariables);
			} else {
				this.dl.addFields(this.getTemplater(this.getOption('tpl.row')).getPlainVariables());
			}
			this.dl.initPagerMode();
		},

		loadData: function (pageNumber) {
			this.waitEvent(this.dl, 'loaded', fox.bind(function (p, dl) {
				this.resetCollection(dl.getCollection());

				if (dl.getPagerData().next !== 0) {
					_.loadNext.call(this);
				}
			}, this));

			if (pageNumber === undefined) {
				this.dl.load();
			} else {
				this.dl.changePage(pageNumber);
			}
		},

		loadNext: function () {
			var
				pagerData = this.dl.getPagerData();

			if (pagerData.cp !== pagerData.total) {
				this.waitEvent(this.dl, 'loaded', fox.bind(function (p, dl) {
					this.bufData = dl.getCollection();
				}, this));

				this.dl.nextPage();
			}
		}
	};

	fox.registerWidget('LazyDataList', {

		configure: function () {
			this.originalData = [];

			this.registerOptions('', {
				cleanUnusedDataTime: 1000 * 60 * 10,
				notOverrideListBehavior: true
			});

			this.callParent('configure', arguments);
		},

		preparing: function () {
			this.callParent('preparing', arguments);

			_.initDatalayer.call(this);
		},

		init: function () {
			this.callParent('init', arguments);

			this.bufData = [];
		},

		running: function () {
			this.callParent('running', arguments);

			_.loadData.call(this);
		},

		activate: function () {
			this.callParent('activate', arguments);

			if (this.getLength() === 0) {
				_.loadData.call(this, 1);
			}

			clearTimeout(this.unusedDataLabelTimer);
		},

		deactivate: function () {
			this.callParent('deactivate', arguments);

			this.originalData = this.getOriginalData();
			_.cleanUnusedData.call(this);
		},

		loadMoreData: function () {
			this.appendItem(this.bufData);
			this.bufData = [];

			if (this.dl._loadStatus == 'loading') {
				this.waitEvent(this.dl, 'loaded', fox.bind(function () {
					this.loadMoreData();
				}, this));
			} else {
				_.loadNext.call(this);
			}
		},

		loadData: function () {
			_.loadData.apply(this, arguments);

			return this;
		},

		setTags: function (tags) {
			this.dispatchEvent('tagsApplied', tags);

			if (tags.length) {
				this.dl.setTransitParameter('tags', tags.join(','));

				return;
			}

			this.dl.clearTransitParameters('tags');
		},

		applyTagsFilter: function (tags) {
			this.dl.setOffset(0);
			this.dl.setCp(1);

			this.setTags(tags);
		},

		filterByTags: function (tags) {
			this.applyTagsFilter(tags);
			this.originalData = this.getOriginalData();

			_.loadData.call(this);
		},

		generateContentLink: function () {
			var contentTypes = {
				3: 'scene',
				20: 'scene', //liveshow
				11: 'gallery'
			};

			fox.each(this.dl.getCollection(), function (data) {
				var accessibility = fox.objectGet(data.accessibility, ['collection', data.id].join('.'))
				var arr = [];

				if (!contentTypes[data.contentType]) {
					console.warn('no such content type for direct link')
				}

				arr = ['/', contentTypes[data.contentType], '/', data.id];

				if (fox.isSet(data.title)) {
					arr.push('/')
					arr.push(fox.utils.toNavigatorAlias(data.title));
				};

				if (!fox.site.member && accessibility.previewsForGuests === 0) {
					arr = [fox.getEnv('siteProps.ubs.joinUrl')];
				};

				data.generatedContentLink = arr.join('');
			}, this);
		}

	}, 'AdvancedList');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/lazyDataList.js
// module id = 876
// module chunks = 4